import React, { Component } from "react";
import Select from "react-select";

// Components
import ErrorWrap from "../../../utils/error-success/ErrorWrap";
import CircleLoader from "../CircleLoader";

class ProfileTableLocation extends Component {
	render() {
		const {
			user,
			inProgress,
			personalFieldsErrors,
			reviewerOptionsLoading,
			reviewerOptionsError,
			reviewerOptions,
			translations
		} = this.props;

		return (
			<React.Fragment>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.address ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.address}:</th>
					<td>
						<input
							type="text"
							id="address"
							value={user.address}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder={translations.sections.reviewer_form.address_placeholder}
						/>
					</td>
				</tr>
				<tr
					className={!!personalFieldsErrors && personalFieldsErrors.city ? `error` : null}
				>
					<th>{translations.sections.reviewer_form.city}:</th>
					<td>
						<input
							type="text"
							id="city"
							value={user.city}
							maxLength="255"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder={translations.sections.reviewer_form.city_placeholder}
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.postal ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.postal}:</th>
					<td>
						<input
							type="text"
							id="postal"
							value={user.postal}
							maxLength="9"
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
							placeholder={translations.sections.reviewer_form.postal_placeholder}
						/>
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.province ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.province}:</th>
					<td>
						{reviewerOptionsError ? (
							<ErrorWrap>{reviewerOptionsError}</ErrorWrap>
						) : (
							<React.Fragment>
								{!!reviewerOptionsLoading && <CircleLoader />}

								{!!reviewerOptions &&
									reviewerOptions.locations &&
									reviewerOptions.locations.provinces && (
										<Select
											classNamePrefix="react-select"
											placeholder={
												translations.sections.form_elements.select_one
											}
											isClearable={false}
											isDisabled={inProgress}
											name={`province`}
											value={reviewerOptions.locations.provinces.filter(
												({ abbreviation }) => abbreviation === user.province
											)}
											onChange={({ abbreviation }) => {
												this.props.updateSelectedValue(
													abbreviation,
													"province"
												);
											}}
											options={reviewerOptions.locations.provinces}
											getOptionLabel={({ name }) => name}
											getOptionValue={({ abbreviation }) => abbreviation}
										/>
									)}
							</React.Fragment>
						)}
					</td>
				</tr>
			</React.Fragment>
		);
	}
}

export default ProfileTableLocation;



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/profile-table/ProfileTableLocation.js